import { observable, flow, makeObservable } from 'mobx';

import BaseStore from './BaseStore';
import TheoryAccessApi from '../api/theory_access';

class TheoryAccessStore extends BaseStore {
  isAccessesChecking = false;
  isPaymentDataLoading = false;
  isPaymentProcessing = false;
  isCodesInfoLoading = false;
  hasRemainingAccesses = false;
  paymentData = {};
  codes = [];

  checkRemainingAccess = flow(function* (schoolId) {
    this.isAccessesChecking = true;

    try {
      const { data } = yield TheoryAccessApi.checkRemainingAccess(schoolId);
      this.hasRemainingAccesses = data.is_available;
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    } finally {
      this.isAccessesChecking = false;
    }
  });

  getPaymentData = flow(function* (schoolId) {
    this.isPaymentDataLoading = true;

    try {
      const { data } = yield TheoryAccessApi.getPaymentData(schoolId);
      this.paymentData = data;
    } finally {
      this.isPaymentDataLoading = false;
    }
  });

  getAvailableCodes = flow(
    function* () {
      this.isCodesInfoLoading = true;

      try {
        const { data } = yield TheoryAccessApi.getAvailableCodes();
        this.codes = data;
      } finally {
        this.isCodesInfoLoading = false;
      }
    },
  );

  constructor() {
    super();

    makeObservable(this, {
      isAccessesChecking: observable,
      isPaymentDataLoading: observable,
      isPaymentProcessing: observable,
      isCodesInfoLoading: observable,
      hasRemainingAccesses: observable,
      paymentData: observable,
      codes: observable,
    });
  }
}

export default new TheoryAccessStore();
